<template>
  <div class="mb-3">
    <vx-card ref="filterCard" :title="report_data.chart_name" :remove-card-action="true" v-on:remove="onRemoveChart"
             :collapse-action="true">
      <div v-if="!isChartHidden" class="vx-row" :id="'sales-revenue-chart-card_'+index_chart">

        <div class="vx-col md:w-1/6 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-100 text-bold">Range</label>
          <v-select :clearable="false" placeholder="" v-model="range_obj"
                    :options="ranges"
                    label="label"
                    @input="onChangeRange()"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>


        <div v-if="range_obj.label === 'Choose Your Own Dates'" class="vx-col md:w-1/6 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-100 text-bold">From</label>
          <flat-pickr :config="{ dateFormat: 'd/m/Y'}" class="w-full" v-model="fixed_filters['from']"
                      placeholder="Choose Date"/>
        </div>
        <div v-if="range_obj.label === 'Choose Your Own Dates'" class="vx-col md:w-1/6 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-100 text-bold">To</label>
          <flat-pickr :config="{ dateFormat: 'd/m/Y'}" class="w-full" v-model="fixed_filters['to']"
                      placeholder="Choose Date"/>
        </div>


        <div class="vx-col md:w-1/6 sm:w-1/2 w-full mt-2" v-if="report_data.report_type !== 'table'">
          <label class="text-sm opacity-100 text-bold">X-axis Interval</label>
          <v-select :clearable="false" placeholder="" v-model="fixed_filters['interval']"
                    :options="x_axis_intervals"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>
        <!--        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">-->
        <!--          <label class="text-sm opacity-100 text-bold">Country</label>-->
        <!--          <v-select :clearable="true" placeholder="" v-model="filters['country']"-->
        <!--                    :options="countries"-->
        <!--                    label="name"-->
        <!--                    :reduce="option => option.name"-->
        <!--                    :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>-->
        <!--        </div>-->

        <div class="vx-col md:w-1/6 sm:w-1/2 w-full mt-2" v-for="(fil, filter_index) in allowed_filter_array"
             :key="filter_index">
          <label class="text-sm opacity-100 text-bold">{{ fil.label }}</label>
          <div v-if="fil.hasOwnProperty('type')">
            <vs-input class="w-full" v-if="fil.type === 'input-field'" v-model="filters[fil.key]"/>
          </div>
          <v-select v-else :clearable="true" placeholder="" v-model="filters[fil.key]"
                    :multiple="fil.multiple"
                    :options="getDropdownOptions(fil)"
                    label="name"
                    :reduce="option => option.value"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>

      </div>

      <div class="vx-row" :class="isChartHidden ? 'my-2' : 'mt-4 mb-16'">
        <div class="vx-col w-full" :class="{'ml-auto': !isChartHidden}">
          <vs-button v-if="!isChartHidden" class="float-right mr-0" size="small"
                     color="warning" type="filled" icon-pack="feather" @click.stop="onClickChartConfig()">Edit Chart
          </vs-button>
          <vs-button v-for="(btn, btn_idx) in download_buttons" :key="btn_idx"
                     :class="isChartHidden ? 'float-left mr-2 mb-2' : 'float-right mr-2'" size="small"
                     color="success" type="filled" icon-pack="feather"
                     @click.stop="onClickDownloadChartDocument(btn.end_point)"> {{ btn.title }}
          </vs-button>
        </div>
      </div>
      <report-table-view
        :data-set="series"
        :headings="report_data.configs.table_keys"
        :sub_headings="report_data.configs.expanded_table"
        v-if="report_data.report_type === 'table' && !isChartHidden"
      />

      <span v-if="report_data.report_type === 'graph' && !isChartHidden" class="text-xl font-bold text-primary">
        Total {{ report_data.configs.yaxis.title.text }} : {{ graph_total | thousand_seperator }}
      </span>
      <vue-apex-charts
        v-if="report_data.report_type !== 'table' && !isChartHidden"
        ref="lineApexChart"
        :type="report_data.chart_type"
        height="300"
        :options="report_data.configs"
        :series="series"/>

      <!--      <vue-apex-charts-->
      <!--        v-show="type === 'pie'"-->
      <!--        ref="pieApexChart"-->
      <!--        :type="report_data.chart_type"-->
      <!--        height="300"-->
      <!--        :options="pie_chart_data.chart_options"-->
      <!--        :series="pie_chart_data.series"/>-->

    </vx-card>
    <chart-configs-side-bar @saveConfig="saveConfig" @refresh-chart-list="RefreshCharts"
                            ref="chartConfigsSideBar"/>
    <download-report-pop-up ref="DownloadReportPopUp"/>
    <download-sales-margin-report-pop-up ref="downloadSalesMarginReportPopUp"/>
    <download-sales-order-report-pop-up ref="downloadSalesOrderReportPopUp"/>
    <download-sales-order-delayed-report-pop-up ref="downloadSalesOrderDelayedReportPopUp"/>
    <download-sales-order-oustanding-report-pop-up ref="downloadSalesOrderOustandingReportPopUp"/>
    <download-sales-order-vs-customer-report-pop-up ref="downloadSalesOrderVsCustomerReportPopUp"/>
    <DownloadMonthEndSalesReportPopUp ref="downloadMonthEndSalesReportPopUp"/>
    <DownloadTopSuppliersReportPopUp ref="downloadTopSuppliersReportPopUp"/>
    <DownloadTopRawMaterialReportPopUp ref="downloadTopRawMaterialReportPopUp"/>
    <DownloadRawMaterialConsumptionReportPopUp ref="downloadRawMaterialConsumptionReportPopUp"/>
    <DownloadSundryConsumptionReportPopUp ref="downloadSundryConsumptionReportPopUp"/>
    <DownloadRawMaterialBatchConsumptionDocumentPopUp ref="downloadRawMaterialBatchConsumptionDocumentPopUp"/>
    <DownloadSundryBatchConsumptionReportPopUp ref="downloadSundryBatchConsumptionReportPopUp"/>
    <DownloadFormulationBatchConsumptionReportPopUp ref="downloadFormulationBatchConsumptionReportPopUp"/>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import VueApexCharts from 'vue-apexcharts'
import moment from "moment";

import {RepositoryFactory} from '@/repository/RepositoryFactory'
import {mapGetters} from "vuex";
import chart_data from "@/constants/charts.js";
import ChartConfigsSideBar from "@/components/sidebars/ChartConfigsSideBar";
import ErrorMessages from "@/mixins/ErrorMessages";
import Filter from "@/mixins/filter";
import SuccessMessage from "@/mixins/SuccessMessage";
import Utils from "@/mixins/Utils";
import ReportTableView from "@/components/report/ReportTableView";
import DownloadReportPopUp from "@/components/popups/report/DownloadReportPopUp";
import DownloadSalesMarginReportPopUp from "@/components/popups/report/DownloadSalesMarginReportPopUp";
import DownloadSalesOrderReportPopUp from "@/components/popups/report/DownloadSalesOrderReportPopUp";
import DownloadSalesOrderDelayedReportPopUp from "@/components/popups/report/DownloadSalesOrderDelayedReportPopUp";
import DownloadSalesOrderOustandingReportPopUp
  from "@/components/popups/report/DownloadSalesOrderOustandingReportPopUp";
import DownloadSalesOrderVsCustomerReportPopUp
  from "@/components/popups/report/DownloadSalesOrderVsCustomerReportPopUp";
import DownloadMonthEndSalesReportPopUp from "@/components/popups/report/DownloadMonthEndSalesReportPopUp";
import DownloadTopSuppliersReportPopUp from "@/components/popups/report/DownloadTopSuppliersReportPopUp";
import DownloadTopRawMaterialReportPopUp from "@/components/popups/report/DownloadTopRawMaterialReportPopUp";
import DownloadRawMaterialConsumptionReportPopUp from '@/components/popups/report/DownloadRawMaterialConsumptionReportPopUp.vue';
import DownloadSundryConsumptionReportPopUp from '@/components/popups/report/DownloadSundryConsumptionReportPopUp.vue';
import DownloadRawMaterialBatchConsumptionDocumentPopUp from '@/components/popups/report/DownloadRawMaterialBatchConsumptionDocumentPopUp.vue';
import DownloadSundryBatchConsumptionReportPopUp from '@/components/popups/report/DownloadSundryBatchConsumptionReportPopUp.vue';
import DownloadFormulationBatchConsumptionReportPopUp from '@/components/popups/report/DownloadFormulationBatchConsumptionReportPopUp.vue';

const ReportingRepository = RepositoryFactory.get('reporting')
const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

export default {
  name: "ChartComponent",
  components: {
    DownloadSalesOrderVsCustomerReportPopUp,
    DownloadSalesOrderOustandingReportPopUp,
    DownloadSalesOrderDelayedReportPopUp,
    DownloadReportPopUp,
    DownloadSalesMarginReportPopUp,
    DownloadSalesOrderReportPopUp,
    DownloadMonthEndSalesReportPopUp,
    ReportTableView,
    DownloadTopSuppliersReportPopUp,
    DownloadTopRawMaterialReportPopUp,
    DownloadRawMaterialConsumptionReportPopUp,
    DownloadSundryConsumptionReportPopUp,
    DownloadRawMaterialBatchConsumptionDocumentPopUp,
    DownloadSundryBatchConsumptionReportPopUp,
    DownloadFormulationBatchConsumptionReportPopUp,
    VueApexCharts,
    'v-select': vSelect,
    flatPickr,
    ChartConfigsSideBar
  },
  props: {
    report_data: {
      default: {},
      type: Object,
      required: true,
    },
    index_chart: {
      required: true,
    }
  },
  data() {
    return {
      is_loaded_completed: false,
      type: 'line',
      chart_types: ['line', 'bar', 'area', 'scatter'],
      ranges: [],
      line_chart_data: {},
      pie_chart_data: {},
      chart_data,
      range_obj: {},
      fixed_filters: {
        interval: this.report_data.interval,
        from: null,
        to:null,
      },
      filters: {},
      allowed_filter_array: [],
      dropdown_data: {},
      chart_name: 'Sales Revenue',
      series_data: [],
      labels: [],
      series: [],
      SI_PREFIXES: [
        {value: 1, symbol: ''},
        {value: 1e3, symbol: 'k'},
        {value: 1e6, symbol: 'M'},
        {value: 1e9, symbol: 'B'},
        {value: 1e12, symbol: 'T'},
        {value: 1e15, symbol: 'Q'},
        {value: 1e18, symbol: 'E'},
        {value: 1e21, symbol: 'S'},
      ]
    }
  },
  created() {
    Object.assign(this.line_chart_data, this.chart_data.line_chart_data)
    Object.assign(this.pie_chart_data, this.chart_data.pie_chart_data)
  },
  /**
   * fetch filters data for dropdowns
   * @returns {Promise<void>}
   */
  async mounted() {
    // this.$refs.filterCard.isContentCollapsed = true
    // this.$refs.filterCard.maxHeight = '1.5rem'
    this.allowed_filter_array = this.report_data.filters
    this.allowed_filter_array.forEach((x) => {
      this.$set(this.dropdown_data, x.name, this.getDropdownData(x.key))
    });

    await this.rangeGenerator()
    if (this.selectedSupplierId) {
      await this.onSupplierFilterChange(this.selectedSupplierId)
    }
  },

  /**
   * destroy apex chart instance from dom
   */
  beforeDestroy() {
    // this.$refs.pieApexChart.destroy()
    if (this.$refs.lineApexChart) {
      this.$refs.lineApexChart.destroy()
    }
  },

  methods: {
    /**
     * open chart config edit side bar
     */
    onClickChartConfig() {
      this.$refs.chartConfigsSideBar.openSideBar(this.report_data)
    },
    async onClickDownloadChartDocument(end_point) {
      switch (end_point) {
        case 'sales-margin-report':
          this.$refs.downloadSalesMarginReportPopUp.openPopup(end_point, this.fixed_filters['from'],this.fixed_filters['to'], this.filters);
          break
        case 'sales-order-report':
          this.$refs.downloadSalesOrderReportPopUp.openPopup(end_point, this.fixed_filters['from'],this.fixed_filters['to'], 'Sales Order Report');
          break
        case 'sales-report' :
          this.$refs.DownloadReportPopUp.openPopup(end_point, this.filters)
          break
        case 'delayed-product-orders-report' :
          this.$refs.downloadSalesOrderDelayedReportPopUp.openPopup(end_point, this.filters)
          break
        case 'outstanding-product-orders-report' :
          this.$refs.downloadSalesOrderOustandingReportPopUp.openPopup(end_point, this.filters)
          break
        case 'product-vs-customer-report' :
          this.$refs.downloadSalesOrderVsCustomerReportPopUp.openPopup(end_point, this.fixed_filters['from'],this.fixed_filters['to'], this.filters);
          break
        case 'month-end-sales-report' :
          this.$refs.downloadMonthEndSalesReportPopUp.openPopup(end_point, this.fixed_filters['from'],this.fixed_filters['to'], this.filters);
          break
        case 'top-suppliers-by-orders' :
          this.$refs.downloadTopSuppliersReportPopUp.openPopup(end_point, this.fixed_filters['from'],this.fixed_filters['to'], this.filters);
          break
        case 'top-raw-materials-by-orders' :
          this.$refs.downloadTopRawMaterialReportPopUp.openPopup(end_point, this.fixed_filters['from'],this.fixed_filters['to'], this.filters);
          break
        case 'raw-material-consumption-report' :
          this.$refs.downloadRawMaterialConsumptionReportPopUp.openPopup(end_point, this.fixed_filters['from'], this.fixed_filters['to'], this.filters);
          break
        case 'sundry-items-consumption-report' :
          this.$refs.downloadSundryConsumptionReportPopUp.openPopup(end_point, this.fixed_filters['from'], this.fixed_filters['to'], this.filters);
          break
        case 'raw-material-batch-consumption-document' :
          this.$refs.downloadRawMaterialBatchConsumptionDocumentPopUp.openPopup(end_point, this.fixed_filters['from'], this.fixed_filters['to'], this.filters);
          break
        case 'sundry-batch-consumption-document' :
          this.$refs.downloadSundryBatchConsumptionReportPopUp.openPopup(end_point, this.fixed_filters['from'], this.fixed_filters['to'], this.filters);
          break
        case 'formulation-batch-consumption-report' :
          this.$refs.downloadFormulationBatchConsumptionReportPopUp.openPopup(end_point, this.fixed_filters['from'], this.fixed_filters['to'], this.filters);
          break
      }
    },

    /**
     * save chart settings and re-render chart with options
     * @param type
     * @param config
     */
    saveConfig({type, config}) {
      try {
        /**
         * chart series update and re-render
         */
        this.type = type
        this.line_chart_data.chart_options = config
        this.$refs.lineApexChart.updateOptions({
          xaxis: {title: {text: config.xaxis.title.text}},
          yaxis: [{title: {text: config.yaxis.title.text}, tickAmount: Number(config.yaxis.tickAmount)}],
          colors: config.colors,
          grid: config.grid,
          stroke: {curve: config.stroke.curve, width: config.stroke.width},
        }, true, true)

      } catch (e) {

      }
    },
    collapse(){
      this.$refs.filterCard.collapse()
    },
    expand(){
      this.$refs.filterCard.expand()
    },
    RefreshCharts() {
      location.reload()
      // this.$emit('refresh-chart-list')
    },

    /**
     * date range pre-defined list generator [last 30 days, 60 days, 90 days and 365 days]
     * @returns {Promise<void>}
     */
    async rangeGenerator() {

      const today = moment().format('DD/MM/YYYY')
      const this_quarter = moment().quarter()

      const start_of_month = moment().startOf('month').format('DD/MM/YYYY');
      const end_of_month = moment().endOf('month').format('DD/MM/YYYY');

      const previous_month_start = moment(today, 'DD/MM/YYYY').subtract(1, 'months').startOf('month').format('DD/MM/YYYY')
      const previous_month_end = moment(today, 'DD/MM/YYYY').subtract(1, 'months').endOf('month').format('DD/MM/YYYY')

      const this_quarter_start = moment().quarter(this_quarter).startOf('quarter').format('DD/MM/YYYY');
      const this_quarter_end = moment().quarter(this_quarter).endOf('quarter').format('DD/MM/YYYY');

      const previous_quarter_start = moment().quarter(this_quarter - 1).startOf('quarter').format('DD/MM/YYYY');
      const previous_quarter_end = moment().quarter(this_quarter - 1).endOf('quarter').format('DD/MM/YYYY');

      const start_of_this_year = moment().startOf('year').format('DD/MM/YYYY');
      const end_of_this_year = moment().endOf('year').format('DD/MM/YYYY');

      const previous_year_start = moment(today, 'DD/MM/YYYY').subtract(1, 'years').startOf('year').format('DD/MM/YYYY')
      const previous_year_end = moment(today, 'DD/MM/YYYY').subtract(1, 'years').endOf('year').format('DD/MM/YYYY')

      // const last_30_days = moment().subtract(30, 'days').format('DD/MM/YYYY')
      // const last_60_days = moment().subtract(60, 'days').format('DD/MM/YYYY')
      // const last_90_days = moment().subtract(90, 'days').format('DD/MM/YYYY')
      // const last_180_days = moment().subtract(180, 'days').format('DD/MM/YYYY')
      // const last_365_days = moment().subtract(365, 'days').format('DD/MM/YYYY')

      // this.ranges = [
      //   {label: 'This Month', value: `${start_of_month} to ${end_of_month}`, key: '30'},
      //   {label: 'Previous Month', value: `${previous_month_start} to ${previous_month_end}`, key: '60'},
      //   {label: 'This Quarter', value: `${this_quarter_start} to ${this_quarter_end}`, key: '90'},
      //   {label: 'Previous Quarter', value: `${previous_quarter_start} to ${previous_quarter_end}`, key: '180'},
      //   {label: 'This Year', value: `${start_of_this_year} to ${end_of_this_year}`, key: '365'},
      //   {label: 'Previous Year', value: `${previous_year_start} to ${previous_year_end}`, key: '600'},
      //   {label: 'Choose Your Own Dates', value: 'own_dates', key: 'own_dates'},
      // ]

      this.ranges = [
        { label: 'This Month', from: start_of_month, to: end_of_month, key: '30' },
        { label: 'Previous Month', from: previous_month_start, to: previous_month_end, key: '60' },
        { label: 'This Quarter', from: this_quarter_start, to: this_quarter_end, key: '90' },
        { label: 'Previous Quarter', from: previous_quarter_start, to: previous_quarter_end, key: '180' },
        { label: 'This Year', from: start_of_this_year, to: end_of_this_year, key: '365' },
        { label: 'Previous Year', from: previous_year_start, to: previous_year_end, key: '600' },
        { label: 'Choose Your Own Dates', from: null, to: null, key: 'own_dates' },
      ]

      if (this.report_data.range) {
        this.range_obj = this.ranges.find((x) => Number(x.key) === this.report_data.range)
        this.fixed_filters['from'] = this.range_obj.from
        this.fixed_filters['to'] = this.range_obj.to
      } else {
        this.range_obj = this.ranges[0]
        this.fixed_filters['from'] = this.ranges[0].from
        this.fixed_filters['to'] = this.ranges[0].to
      }
    },

    /**
     * set the date range when click on range pre-defined list
     */
    async onChangeRange() {
      if (this.range_obj.value !== 'own_dates') {
        this.fixed_filters['from'] = this.range_obj.from
        this.fixed_filters['to'] = this.range_obj.to
      }
    },
    async filterQueryUpdate() {
      await this.getChartData()
    },

    /**
     * fetching chart data
     * @returns {Promise<void>}
     */
    async getChartData() {
      if (this.isChartHidden) return
      await this.$vs.loading({
        container: `#sales-revenue-chart-card_${this.index_chart}`,
        scale: 0.45
      })
      try {
        // let arr = this.fixed_filters['range'].split(' to ')
        if (this.fixed_filters['from'] && this.fixed_filters['to']) {
          const data = (await ReportingRepository.getChartData(
            this.report_data.endpoint,
            this.fixed_filters['from'],
            this.fixed_filters['to'],
            this.fixed_filters.interval,
            this.formatted_filters,
          )).data
          if (this.report_data.report_type === 'table') {
            this.series = data.data ? data.data : data
          } else {
            await this.setChartLabelsAndValues(data.data ? data.data : data)
          }
        }
      } catch (e) {
        // this.showErrorMessageWithTitle('Something went wrong', `${this.report_data.chart_name} failed. Please contact admin`)
      }
      this.$vs.loading.close(`#sales-revenue-chart-card_${this.index_chart} > .con-vs-loading`)
    },

    async setChartLabelsAndValues(data) {
      this.series_data = data.map((x) => Number(x.value))
      this.labels = data.map((x) => x.label)

      // set line chart data & series
      // this.line_chart_data.series[0].name = this.report_data.yaxis
      // this.line_chart_data.series[0].data = this.series_data
      // this.line_chart_data.chart_options.xaxis.categories = this.labels

      //set pie chart data & series
      // this.pie_chart_data.series = this.series_data
      // this.pie_chart_data.chart_options.labels = this.labels

      // this.$refs.pieApexChart.updateOptions({
      //   series: [{data: this.series_data}],
      //   labels: this.labels
      // });

      if (this.report_data.report_type === 'multi_line_graph') {
        const keys = Object.keys(data[0].value)
        let seriesData = []
        keys.forEach((key, index) => {
          seriesData[index] = []
        })

        data.map((item) => {
          keys.forEach((key, index) => {
            seriesData[index].push(item.value[key])
          })
        })

        const seriesArray = keys.map((key, index) => {
          return {
            data: seriesData[index],
            name: key
          }
        })

        this.$refs.lineApexChart.updateOptions({
          series: seriesArray,
          xaxis: {categories: this.labels},
          yaxis: {
            labels: {
              formatter: (val) => {
                return val
              }
            },
            title: {text: this.report_data.configs.yaxis.title.text}
          },
          dataLabels: {
            enabled: true,
            formatter: (val) => {
              return this.abbreviateNumber(val)
            },
          }
        });
      }

      if (this.report_data.chart_type !== 'pie' && this.report_data.report_type !== 'multi_line_graph') {
        this.$refs.lineApexChart.updateOptions({
          series: [{data: this.series_data, name: this.report_data.yaxis}],
          xaxis: {categories: this.labels},
          yaxis: {
            labels: {
              formatter: (val) => {
                return val
              }
            },
            title: {text: this.report_data.configs.yaxis.title.text}
          },
          dataLabels: {
            enabled: true,
            formatter: (val) => {
              return this.abbreviateNumber(val)
            },
          }
        });
      }
      if (this.report_data.chart_type === 'pie') {
        this.$refs.lineApexChart.updateOptions({
          series: this.series_data,
          labels: this.labels,
        });
      }

    },
    async onRemoveChart() {
      try {
        await ReportingRepository.deleteChart(this.report_data.id)
        this.showSuccessMessage('Chart deleted successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    abbreviateNumber(number) {
      if (number === 0) return number
      const tier = this.SI_PREFIXES.filter((n) => number >= n.value).pop()
      if (tier) {
        const numberFixed = (number / tier.value).toFixed(0)

        return `${numberFixed}${tier.symbol}`
      }
    },
    async onSupplierFilterChange(supplierId) {
      if (!this.allowed_filter_array.some(function (f) { return f.name === 'raw_materials' })) {
        return
      }

      var supplierIdsStr = ''
      if (Array.isArray(supplierId)) {
        supplierIdsStr = supplierId.filter(function (id) { return id !== null && id !== undefined && id !== '' }).join(',')
      } else if (supplierId) {
        supplierIdsStr = String(supplierId)
      }

      if (supplierIdsStr) {
        try {
          const res = (await SupplierRawMaterialRepository.getRawMaterialAcceptedList(1, 'filter[supplier_ids]=' + supplierIdsStr, 150, '', 0)).data
          const data = Array.isArray(res) ? res : (res.data || [])
          const mappedRms = data.map(function (x) {
            return {
              name: ((x.category && x.category.prefix) || '') + '-' + x.company_product_code,
              value: x.id
            }
          })
          this.$set(this.dropdown_data, 'raw_materials', mappedRms)

          if (this.filters['raw-material-id']) {
            const validIds = mappedRms.map(function (r) { return r.value })
            if (Array.isArray(this.filters['raw-material-id'])) {
              this.filters['raw-material-id'] = this.filters['raw-material-id'].filter(function (id) {
                return validIds.indexOf(id) !== -1
              })
            } else if (validIds.indexOf(this.filters['raw-material-id']) === -1) {
              this.filters['raw-material-id'] = null
            }
          }
        } catch (e) {
          this.$set(this.dropdown_data, 'raw_materials', this.getDropdownData('raw-material-id'))
        }
      } else {
        this.$set(this.dropdown_data, 'raw_materials', this.getDropdownData('raw-material-id'))
      }
    },
    getDropdownOptions(fil) {
      if (fil.name === 'raw_materials' && this.selectedSupplierId) {
        return this.dropdown_data['raw_materials'] || []
      }
      const data = this.getDropdownData(fil.key)
      return (data && data.length) ? data : (this.dropdown_data[fil.name] || [])
    },
  },
  computed: {
    ...mapGetters(['customers', 'countries']),

    /**
     * date range gap calculation and interval dropdown generate
     * @returns {string[]}
     */
    x_axis_intervals: function () {
      if (!this.fixed_filters['range']) {
        return []
      }
      let arr = this.fixed_filters['range'].split(' to ')
      let from = moment(arr[0], 'DD/MM/YYYY')
      let to = moment(arr[1], 'DD/MM/YYYY')
      if (arr.length !== 2) {
        return []
      }
      let gap = to.diff(from, 'days')
      if (gap < 8) {
        this.fixed_filters['interval'] = 'daily'
        return ['daily']
      } else if (gap < 30) {
        this.fixed_filters['interval'] = 'weekly'
        return ['weekly', 'daily']
      } else {
        return ['monthly', 'weekly', 'daily']
      }
    },
    graph_total: function () {
      if (this.report_data.report_type !== 'graph') return 0
      return this.series_data.reduce((acc, curr) => acc + Number(curr), 0)
    },
    formatted_filters: function() {
      let queryParts = this.filterQuery.split("&");
      let processedQuery = queryParts.map((part) => {
          let [key, value] = part.split("=")

          let actualKey = key.match(/\[([^\]]+)\]/);
          actualKey = actualKey ? actualKey[1] : key

          let filter = this.allowed_filter_array.find((f) => f.key === actualKey)

          if (filter && filter.raw_filters) {
              return `${actualKey}=${value}`
          }
          return part
      });
      return processedQuery.join("&")
    },
    isChartHidden: function () {
      return Boolean(
        (this.report_data && this.report_data.configs && this.report_data.configs.hide_chart) ||
        (this.report_data && this.report_data.hide_chart)
      )
    },
    download_buttons: function () {
      const btn = this.report_data && this.report_data.configs ? this.report_data.configs.view_download_button : null;
      if (!btn) return [];
      if (Array.isArray(btn)) return btn;
      return [{ title: 'Download Report', end_point: btn }];
    },
    selectedSupplierId: function () {
      return this.filters ? this.filters['supplier-id'] : null
    },
  },
  mixins: [ErrorMessages, Filter, SuccessMessage, Utils],
  watch: {
    'fixed_filters': {
      handler(newVal, oldVal) {
        this.getChartData()
      },
      deep: true
    },
    selectedSupplierId: {
      async handler(newVal) {
        await this.onSupplierFilterChange(newVal)
      },
      deep: true
    }
  },
}
</script>

<style scoped>

</style>
